export default __webpack_public_path__ + "static/media/bzpublish.f4324006.png";